import Routes from "@/common/router/Routes";
import SensorRouter from "@/context/sensor/router/SensorRouter";

export default class SensorRoutes extends Routes {
  constructor() {
    super({
      label: "Sensor",
      router: new SensorRouter(),
      lazyPage: () => import("@/context/sensor/page/SensorPage.vue"),
      lazyCreate: () => import("@/context/sensor/containers/SensorCreateContainer.vue"),
      lazyUpdate: () => import("@/context/sensor/containers/SensorUpdateContainer.vue"),
      lazyList: () => import("@/context/sensor/containers/SensorListContainer.vue"),
      lazyShow: () => import("@/context/sensor/containers/SensorShowContainer.vue")
    });
  }
}
